// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- Consumers compile this library source without its owning tsconfig.
/// <reference path="../../../../typedefs/svg-url.d.ts" />

export * from './lib/getEmojiSvg'
export * from './lib/unicodeToEmojiSvg'
